export interface ICustomViewFormData {
  name: string;
  shared?: boolean;
}

export const initialValues: (isAdmin: boolean) => ICustomViewFormData = isAdmin => ({
  name: "",
  ...(isAdmin ? { shared: false } : {}),
});
